export const REFRESH_USER_COUNT = 'REFRESH_USER_COUNT';

import { get, put, post, destroy, upload } from 'utils/fetchRequest';

export const uploadImage = async (data) => {
    try {
        const result = await upload('files/link', data);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const getLocationList = async (searchText) => {
    try {
        const result = await get(`location${searchText ? `?search=${encodeURIComponent(searchText)}` : ''}`);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const getLocationContent = async (newsId) => {
    try {
        const result = await get(`location/${newsId}`);
        return result;
    } catch (err) {
        return { error: err };
    }
};

export const createLocation = async (data) => {
    try {
        const result = await post('location', data);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const updateLocation = async (id, data) => {
    try {
        const result = await put(`location/${id}`, data);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const deleteLocation = async (id) => {
    try {
        const result = await destroy(`location/${id}`);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const setSpecial = async (id, data) => {
    try {
        const result = await put(`location/special/${id}`, data);

        return result;
    } catch (err) {
        return { error: err };
    }
};
